// ============================================
// Easyfi Product Attachments H2 zu H4 machen
// ============================================


(function () {
  const SELECTOR = ".tigren-product-attachments .tigren-title-header";

  function replaceHeading() {
    const el = document.querySelector(SELECTOR);
    if (!el || el.tagName === "H4") return el?.tagName === "H4";

    const h4 = document.createElement("h4");
    h4.className = el.className;
    h4.innerHTML = el.innerHTML;
    el.replaceWith(h4);
    return true;
  }

  // Sofort versuchen
  if (replaceHeading()) return;

  // MutationObserver für lazy-loaded Content
  const observer = new MutationObserver(() => {
    if (replaceHeading()) observer.disconnect();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Fallback-Timeout nach 5s
  setTimeout(() => observer.disconnect(), 5000);
})();


// ============================================
// Tepo Dropdown: Heading in den Input-Container verschieben
// + Tooltip neben QS positionieren
// ============================================

(function() {
  const processedFields = new WeakSet();
  const positionCache = new WeakMap();
  const observedButtons = new WeakSet();
  
  let resizeObserver;
  
  function moveHeadingToInput(field) {
    if (processedFields.has(field)) {
      updateHeadingPosition(field);
      return;
    }
    
    const heading = field.querySelector(':scope > .tcustomizer-field__heading');
    const input = field.querySelector('.tcustomizer-field__input');
    
    if (heading && input && !input.contains(heading)) {
      input.insertBefore(heading, input.firstChild);
    }
    
    processedFields.add(field);
    updateHeadingPosition(field);
  }
  
  function updateHeadingPosition(field) {
    const input = field.querySelector('.tcustomizer-field__input');
    const movedHeading = input?.querySelector(':scope > .tcustomizer-field__heading');
    
    if (!movedHeading) return;
    
    const dropdownButton = field.querySelector('.tcustomizer__dropdown-button.tcustomizer__dropdown-select');
    if (!dropdownButton) return;
    
    if (resizeObserver && !observedButtons.has(dropdownButton)) {
      resizeObserver.observe(dropdownButton);
      observedButtons.add(dropdownButton);
    }
    
    const inputRect = input.getBoundingClientRect();
    const buttonRect = dropdownButton.getBoundingClientRect();
    
    const buttonLeft = Math.round(buttonRect.left - inputRect.left);
    const buttonRight = Math.round(inputRect.right - buttonRect.right);
    
    const newLeft = buttonLeft > 50 ? buttonLeft + 11 : 11;
    const newRight = buttonRight + 12;
    
    const cached = positionCache.get(field);
    if (cached && cached.left === newLeft && cached.right === newRight) {
      return;
    }
    
    positionCache.set(field, { left: newLeft, right: newRight });
    
    movedHeading.style.setProperty('left', newLeft + 'px', 'important');
    movedHeading.style.setProperty('right', newRight + 'px', 'important');
  }

  function moveTooltipAfterQS(field) {
    const dropdownContainer = field.querySelector('.tcustomizer__dropdown-image, .tcustomizer__dropdown');
    if (!dropdownContainer) return;
    
    const input = field.querySelector('.tcustomizer-field__input');
    const heading = input?.querySelector(':scope > .tcustomizer-field__heading');
    const tooltip = heading?.querySelector('.tcustomizer-tooltip__icon');
    const tooltipInContainer = dropdownContainer.querySelector(':scope > .tcustomizer-tooltip__icon');
    
    const qs = field.querySelector('.tcustomizer-quantity-selector');
    const qsVisible = qs && qs.offsetParent !== null;
    
    if (tooltip && qsVisible && !dropdownContainer.contains(tooltip)) {
      dropdownContainer.appendChild(tooltip);
      positionCache.delete(field);
      requestAnimationFrame(() => updateHeadingPosition(field));
    } else if (tooltipInContainer && !qsVisible && heading) {
      heading.appendChild(tooltipInContainer);
      positionCache.delete(field);
      requestAnimationFrame(() => updateHeadingPosition(field));
    } else if (qsVisible) {
      requestAnimationFrame(() => updateHeadingPosition(field));
    }
  }

  function processField(field) {
    moveHeadingToInput(field);
    moveTooltipAfterQS(field);
  }

  function getDropdownFields(container) {
    const allFields = container.querySelectorAll('.tcustomizer-field');
    const result = [];
    allFields.forEach(field => {
      if (field.querySelector('.tcustomizer__dropdown-select')) {
        result.push(field);
      }
    });
    return result;
  }

  function processAllDropdowns(container) {
    getDropdownFields(container).forEach(processField);
  }

  // Alle Tepo-Container Selektoren (Produktseite + Edit-Popup im Warenkorb)
  const TEPO_SELECTORS = '.tcustomizer-widget, .tcustomizer-form, .tcustomizer-customization-form';
  const initializedContainers = new WeakSet();

  function initContainer(tepoContainer) {
    if (initializedContainers.has(tepoContainer)) return;
    initializedContainers.add(tepoContainer);

    if (!resizeObserver) {
      resizeObserver = new ResizeObserver(entries => {
        for (const entry of entries) {
          const field = entry.target.closest('.tcustomizer-field');
          if (field) {
            positionCache.delete(field);
            updateHeadingPosition(field);
          }
        }
      });
    }

    processAllDropdowns(tepoContainer);

    let isThrottled = false;
    let pendingUpdate = false;

    const observer = new MutationObserver(function(mutations) {
      const isRelevant = mutations.some(m => {
        if (m.type === 'attributes' && m.attributeName === 'style') {
          return !m.target.classList.contains('tcustomizer-field__heading');
        }
        if (m.type === 'childList') {
          return m.target.closest('.tcustomizer-field') !== null;
        }
        return false;
      });

      if (!isRelevant) return;

      if (isThrottled) {
        pendingUpdate = true;
        return;
      }

      processAllDropdowns(tepoContainer);
      isThrottled = true;

      setTimeout(function() {
        isThrottled = false;
        if (pendingUpdate) {
          pendingUpdate = false;
          processAllDropdowns(tepoContainer);
        }
      }, 100);
    });

    observer.observe(tepoContainer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style']
    });
  }

  function initAll() {
    document.querySelectorAll(TEPO_SELECTORS).forEach(initContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Globaler Observer: erkennt dynamisch geladene Tepo-Container
  // (z.B. Edit-Options-Popup im Warenkorb via #tcustomizer-modals)
  new MutationObserver(function(mutations) {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches(TEPO_SELECTORS)) {
          initContainer(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll(TEPO_SELECTORS).forEach(initContainer);
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();




// Tooltip-Styles einmalig injizieren
const style = document.createElement('style');
style.textContent = `
  #fina-tooltip {
    opacity: 0;
    transform: translateX(-50%) translateY(-100%) translateY(4px);
    transition: opacity .15s ease, transform .15s ease;
  }
  #fina-tooltip.visible {
    opacity: 1;
    transform: translateX(-50%) translateY(-100%);
  }
  #fina-tooltip__arrow {
    position: absolute;
    bottom: -6px;
    left: 50%;
    transform: translateX(-50%);
    width: 12px;
    height: 6px;
    clip-path: polygon(0 0, 100% 0, 50% 100%);
    background: var(--tcustomizer-tooltip-bg-color, #333);
  }
  #fina-tooltip__inner {
    overflow: hidden;
    border-radius: var(--tcustomizer-tooltip-border-radius, 4px);
  }
  /* Kein Platz ueber dem Ausloeser: Tooltip klappt nach unten, Pfeil nach oben */
  #fina-tooltip.unten {
    transform: translateX(-50%) translateY(-4px);
  }
  #fina-tooltip.unten.visible {
    transform: translateX(-50%);
  }
  #fina-tooltip.unten #fina-tooltip__arrow {
    top: -6px;
    bottom: auto;
    clip-path: polygon(50% 0, 100% 100%, 0 100%);
  }
`;
document.head.appendChild(style);

let activeItem = null;
let isTouch = false;

// Tooltip-Ausloeser: Quickify/Tepo-Optionsbilder + FinA-Elemente mit data-fina-tip-img
// (z.B. Zugabe-Kachel, snippets/fina-aktion-zugabe.liquid)
const FINA_TIP_SEL = '.tcustomizer-tooltip, [data-fina-tip-img]';

// Saubere scharfe URL erzeugen: ALLE w= Parameter entfernen, einen einzigen w=480 setzen
// (Bild 240 CSS-px breit, 2x-Displays)
function getSharpUrl(bgUrl) {
  if (!bgUrl) return null;
  try {
    const u = new URL(bgUrl);
    u.searchParams.delete('w');
    u.searchParams.set('w', '480');
    return u.href;
  } catch (e) {
    return bgUrl;
  }
}

function removeTooltip() {
  const tip = document.getElementById('fina-tooltip');
  if (tip) tip.remove();
  activeItem = null;
}

document.addEventListener('scroll', removeTooltip, { capture: true, passive: true });

function showTooltip(item) {
  removeTooltip();
  activeItem = item;

  // FinA-Element: Bild-URL + Text direkt aus data-Attributen (URL ist schon eine
  // fertig dimensionierte Shopify-CDN-URL -> kein getSharpUrl)
  const finaTip = item.hasAttribute('data-fina-tip-img');
  let text, bgUrl;

  if (finaTip) {
    bgUrl = item.getAttribute('data-fina-tip-img');
    text = item.getAttribute('data-fina-tip-text')?.trim();
  } else {
    const original = item.querySelector('.tcustomizer-tooltip--content');
    if (!original) return;

    text = original.querySelector('.tooltip-text')?.textContent?.trim();
    const imgEl = original.querySelector('.tooltip-image');
    bgUrl = imgEl?.style.backgroundImage?.match(/url\(["']?(.+?)["']?\)/)?.[1];
  }

  if (!text && !bgUrl) return;

  const tip = document.createElement('div');
  tip.id = 'fina-tooltip';

  const inner = document.createElement('div');
  inner.id = 'fina-tooltip__inner';

  const rect = item.getBoundingClientRect();

  Object.assign(tip.style, {
    position: 'fixed',
    zIndex: '99999',
    pointerEvents: 'none',
    width: '240px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
    backgroundColor: 'var(--tcustomizer-tooltip-bg-color, #333)',
    borderRadius: 'var(--tcustomizer-tooltip-border-radius, 4px)'
  });

  if (bgUrl) {
    const img = document.createElement('div');
    const sharpUrl = finaTip ? bgUrl : getSharpUrl(bgUrl);

    // Bild fuellt die feste Tooltip-Breite immer ganz (kein dunkler Streifen bei langem Text)
    Object.assign(img.style, {
      display: 'block',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      width: '100%',
      aspectRatio: '1 / 1',
      backgroundImage: `url(${sharpUrl})`
    });

    inner.appendChild(img);
  }

  if (text) {
    const txt = document.createElement('div');
    txt.textContent = text;
    Object.assign(txt.style, {
      padding: '8px 12px',
      fontSize: 'var(--font-size-body-smallest, 12px)',
      fontWeight: '400',
      color: '#fff',
      textAlign: 'center'
    });
    inner.appendChild(txt);
  }

  tip.appendChild(inner);

  const arrow = document.createElement('div');
  arrow.id = 'fina-tooltip__arrow';
  tip.appendChild(arrow);

  document.body.appendChild(tip);

  const tipW = tip.offsetWidth;
  const pad = 8;
  let left = rect.left + rect.width / 2;
  const minLeft = tipW / 2 + pad;
  const maxLeft = window.innerWidth - tipW / 2 - pad;
  left = Math.max(minLeft, Math.min(maxLeft, left));

  const arrowOffset = (rect.left + rect.width / 2) - left;
  arrow.style.left = `calc(50% + ${arrowOffset}px)`;

  tip.style.left = `${left}px`;
  tip.style.top = `${rect.top - pad}px`;

  // Seit dem 240px-Bild ist der Tooltip hoeher — reicht der Platz oben nicht, unter den Ausloeser
  if (rect.top - pad - tip.offsetHeight < pad) {
    tip.classList.add('unten');
    tip.style.top = `${rect.bottom + pad}px`;
  }

  setTimeout(() => tip.classList.add('visible'), 10);
}

document.addEventListener('touchstart', () => { isTouch = true; }, { once: true, passive: true });

document.addEventListener('touchstart', (e) => {
  const item = e.target.closest(FINA_TIP_SEL);
  if (!item) {
    removeTooltip();
    return;
  }
  if (item === activeItem) {
    removeTooltip();
    return;
  }
  showTooltip(item);
}, { passive: true });

document.addEventListener('mouseover', (e) => {
  if (isTouch) return;
  const item = e.target.closest(FINA_TIP_SEL);
  if (!item) return;
  showTooltip(item);
});

document.addEventListener('mouseout', (e) => {
  if (isTouch) return;
  const item = e.target.closest(FINA_TIP_SEL);
  if (!item) return;

  const related = e.relatedTarget?.closest?.(FINA_TIP_SEL);
  if (related === item) return;

  const tip = document.getElementById('fina-tooltip');
  if (!tip) return;

  activeItem = null;
  tip.classList.remove('visible');
  setTimeout(() => tip.remove(), 150);
});


// ============================================
// Back-to-top: Compare Drawer Collision Fix
// ============================================

(function() {
  var drawer = document.querySelector('.product-compare-drawer');
  var btn = document.querySelector('[data-back-to-top]');
  if (!drawer || !btn) return;

  var baseBottom = parseFloat(getComputedStyle(btn).bottom) || 8;

  function measure() {
    var drawerRect = drawer.getBoundingClientRect();
    var visibleHeight = window.innerHeight - drawerRect.top;
    if (visibleHeight > 0) {
      btn.style.bottom = (visibleHeight + 12) + 'px';
    }
  }

  function update() {
    var state = drawer.getAttribute('data-animation-state');
    if (state === 'closed' || state === 'open') {
      drawer.addEventListener('transitionend', measure, { once: true });
    } else {
      btn.style.bottom = '';
    }
}

  // Watch drawer state changes
  new MutationObserver(update).observe(drawer, {
    attributes: true,
    attributeFilter: ['data-animation-state']
  });

  // Watch drawer size changes (window resize, products added/removed)
  new ResizeObserver(update).observe(drawer);
})();



// ============================================
// SellEasy Carousel - Nav Visibility based on scroll position
// ============================================

(function(){
  var style = document.createElement('style');
  style.id = 'selleasy-nav-fix';
  style.textContent = '.selleasy-nav-hidden { visibility: hidden !important; pointer-events: none !important; }';

  function initSellEasyNav(){
    if(!document.getElementById('selleasy-nav-fix')){
      document.head.appendChild(style);
    }

    var containers = document.querySelectorAll('.lb-upsell-carousel-container');
    if(!containers.length) return false;

    var success = false;

    containers.forEach(function(container){
      var navs = container.querySelectorAll('.lb-upsell-ppa-carousel-nav');
      var track = container.querySelector('.lb-upsell-ppa-carousel');
      if(navs.length < 2 || !track) return;

      success = true;
      var prevBtn = navs[0];
      var nextBtn = navs[navs.length - 1];

      function updateNav(){
        var scrollLeft = Math.round(track.scrollLeft);
        var maxScroll = track.scrollWidth - track.clientWidth;

        prevBtn.classList.toggle('selleasy-nav-hidden', scrollLeft <= 2);
        nextBtn.classList.toggle('selleasy-nav-hidden', scrollLeft >= (maxScroll - 2));
      }

      track.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav, { passive: true });
      updateNav();
    });

    return success;
  }

  // Polling: warte bis Navs gerendert sind (max 10 Sekunden)
  var attempts = 0;
  var maxAttempts = 20;
  var pollInterval = setInterval(function(){
    attempts++;
    if(initSellEasyNav() || attempts >= maxAttempts){
      clearInterval(pollInterval);
    }
  }, 500);
})();

// ============================================
// Tepo Sub-Items im Warenkorb: X-Button ausblenden, Quantity deaktivieren
// Sub-Items = von Tepo automatisch hinzugefügte Zusatzprodukte
// ============================================

(function() {
  var cartList = document.querySelector('.cartitems--list');
  if (!cartList) return;

  var HINT_TEXT = 'Dieses Produkt kann nur über "Edit options" bearbeitet oder entfernt werden.';
  var HINT_SELECTOR = '.tepo-sub-item .cart-item__remove, .tepo-sub-item .quantity-selector';
  var activeHintEl = null;

  // Hint-Tooltip: nutzt bestehendes #fina-tooltip CSS
  function showHintTooltip(el) {
    removeTooltip();
    activeHintEl = el;

    var tip = document.createElement('div');
    tip.id = 'fina-tooltip';

    var inner = document.createElement('div');
    inner.id = 'fina-tooltip__inner';

    var txt = document.createElement('div');
    txt.textContent = HINT_TEXT;
    Object.assign(txt.style, {
      padding: '8px 12px',
      fontSize: 'var(--font-size-body-smallest, 12px)',
      fontWeight: '400',
      color: '#fff',
      textAlign: 'center'
    });
    inner.appendChild(txt);

    var arrow = document.createElement('div');
    arrow.id = 'fina-tooltip__arrow';

    tip.appendChild(inner);
    tip.appendChild(arrow);

    Object.assign(tip.style, {
      position: 'fixed',
      zIndex: '99999',
      pointerEvents: 'none',
      maxWidth: '240px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
      backgroundColor: 'var(--tcustomizer-tooltip-bg-color, #333)',
      borderRadius: 'var(--tcustomizer-tooltip-border-radius, 4px)'
    });

    document.body.appendChild(tip);

    var rect = el.getBoundingClientRect();
    var tipW = tip.offsetWidth;
    var pad = 8;
    var left = rect.left + rect.width / 2;
    var minLeft = tipW / 2 + pad;
    var maxLeft = window.innerWidth - tipW / 2 - pad;
    left = Math.max(minLeft, Math.min(maxLeft, left));

    var arrowOffset = (rect.left + rect.width / 2) - left;
    arrow.style.left = 'calc(50% + ' + arrowOffset + 'px)';

    tip.style.left = left + 'px';
    tip.style.top = (rect.top - pad) + 'px';

    setTimeout(function() { tip.classList.add('visible'); }, 10);
  }

  function removeHintTooltip() {
    if (!activeHintEl) return;
    removeTooltip();
    activeHintEl = null;
  }

  // Mouse: hover
  document.addEventListener('mouseover', function(e) {
    if (isTouch) return;
    var target = e.target.closest(HINT_SELECTOR);
    if (!target) return;
    showHintTooltip(target);
  });

  document.addEventListener('mouseout', function(e) {
    if (isTouch) return;
    var target = e.target.closest(HINT_SELECTOR);
    if (!target) return;
    var related = e.relatedTarget && e.relatedTarget.closest ? e.relatedTarget.closest(HINT_SELECTOR) : null;
    if (related === target) return;
    var tip = document.getElementById('fina-tooltip');
    if (!tip) return;
    activeHintEl = null;
    tip.classList.remove('visible');
    setTimeout(function() { tip.remove(); }, 150);
  });

  // Touch: tap toggle
  document.addEventListener('touchstart', function(e) {
    var target = e.target.closest(HINT_SELECTOR);
    if (!target) {
      if (activeHintEl) removeHintTooltip();
      return;
    }
    e.preventDefault();
    if (activeHintEl === target) {
      removeHintTooltip();
    } else {
      showHintTooltip(target);
    }
  }, { passive: false });

  function markTepoSubItems() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        cart.items.forEach(function(item) {
          if (!item.properties) return;

          // Tepo Sub-Items haben eine _parentKey Property
          if (!item.properties._parentKey) return;

          // DOM-Element finden
          var el = document.querySelector('[data-cartitem-key="' + item.key + '"]');
          if (!el) return;

          el.classList.add('tepo-sub-item');
        });
      });
  }

  markTepoSubItems();

  // Nach Cart-Updates erneut prüfen (debounced)
  var debounceTimer;
  new MutationObserver(function() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function() {
      document.querySelectorAll('.tepo-sub-item').forEach(function(el) {
        el.classList.remove('tepo-sub-item');
      });
      markTepoSubItems();
    }, 300);
  }).observe(cartList, { childList: true, subtree: true });
})();


/* ==========================================================================
   Rapid Reviews Sticky Tab – Klammern um den Review-Count entfernen
   Rapid rendert den Count als literalen Text "(116)" -> CSS kann das nicht
   strippen. Leichter Poll bis der async geladene Reiter da ist (max ~12s),
   strippt die Klammern und stoppt dann von selbst (kein Dauer-Observer).
   ========================================================================== */
(function stripRapidStickyParens() {
  function strip() {
    var c = document.querySelector('.gs_badge .gs_count');
    if (c && /[()]/.test(c.textContent)) c.textContent = c.textContent.replace(/[()]/g, '');
  }
  strip();
  var tries = 0;
  var iv = setInterval(function () {
    strip();
    if (++tries > 40) clearInterval(iv);
  }, 300);
})();


/* ==========================================================================
   Rapid Reviews Sticky Tab – feste Position relativ zum WhatsApp-Button
   --------------------------------------------------------------------------
   Rapid setzt die Badge-Position als Inline-`top` (JS, beim Load berechnet aus
   der Badge-Größe). Beim Fenster-Resize ändert unser CSS die Größe (compact↔
   groß, Font, Label), aber Rapids Inline-`top` bleibt stale → der Tab verrutscht
   und der Abstand zum WhatsApp-Button stimmt nicht mehr (erst ein Reload fixt es).
   Fix: den Tab reaktiv so positionieren, dass seine Unterkante immer GAP px über
   der WhatsApp-Button-Oberkante sitzt – konstanter Abstand wie beim alten
   Judge.me-Floating-Tab, neu ausgerichtet bei Load / Resize / Modal-Schließen.
   Nur eingeklappt; im offenen Modal positioniert das zentrale CSS (.open).
   ========================================================================== */
(function rapidStickyTabFixedPosition() {
  var GAP = 27; // px: Badge-Unterkante -> WhatsApp-Button-Oberkante (Bestand)

  function reposition() {
    // Mobile: WhatsApp-Button sitzt rechts unten (Standalone) — Badge NICHT daran ausrichten
    var waTab = document.querySelector(".whatsapp-floating-tab");
    var waBp = waTab ? parseInt(waTab.getAttribute("data-fina-mobile-bp"), 10) || 769 : 769;
    if (window.matchMedia("(max-width: " + waBp + "px)").matches) return;
    var wrap = document.querySelector('.rapid_reviews_global_sticky');
    if (!wrap || wrap.classList.contains('open')) return;
    var badge = wrap.querySelector('.gs_badge');
    var wa = document.querySelector('.whatsapp-floating-tab');
    if (!badge || !wa) return;
    var b = badge.getBoundingClientRect();
    var w = wa.getBoundingClientRect();
    if (!b.height || !w.height) return; // noch nicht gerendert
    var delta = (w.top - GAP) - b.bottom;
    if (Math.abs(delta) < 0.5) return; // sitzt schon korrekt
    var curTop = parseFloat(badge.style.top) || 0;
    badge.style.top = (curTop + delta) + 'px';
  }

  // Load: pollen bis der async geladene Reiter da ist (max ~12s)
  var tries = 0;
  var iv = setInterval(function () {
    reposition();
    if (++tries > 40) clearInterval(iv);
  }, 300);

  // Resize: debounced neu ausrichten (CSS-Größe hat sich schon angewendet)
  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(reposition, 120);
  }, { passive: true });

  // Modal auf/zu: bei Klassen-Wechsel (.open) neu ausrichten, sobald Layout steht
  function observeWrap() {
    var wrap = document.querySelector('.rapid_reviews_global_sticky');
    if (!wrap) return false;
    new MutationObserver(function () {
      requestAnimationFrame(reposition);
    }).observe(wrap, { attributes: true, attributeFilter: ['class'] });
    return true;
  }
  if (!observeWrap()) {
    var t2 = 0;
    var iv2 = setInterval(function () {
      if (observeWrap() || ++t2 > 40) clearInterval(iv2);
    }, 300);
  }
})();


// ============================================
// Rapid Reviews: Grid-Sterne im Globo-gefilterten Collection-Grid
// Globos Produkt-Template kann keine Metafelder lesen -> Daten via window.FINA_RR_MAP
// (server-seitig: snippets/fina-rr-grid-map.liquid); Sterne via Rapids globaler
// rr_drawStarsBadge(badgeEl) gezeichnet (exaktes App-Block-Styling).
// Slot-Markup: .fina-rr-slot in snippets/globo.filter.product.liquid.
// ============================================
(function () {
  function init() {
    var grid = document.querySelector("[data-globo-filter-items]");
    if (!grid || !window.FINA_RR_MAP) return;

    function handleFromUrl(url) {
      if (!url) return "";
      var rest = url.split("/products/")[1];
      return rest ? rest.split("?")[0].split("#")[0].split("/")[0] : "";
    }

    function fillSlot(slot) {
      if (slot.getAttribute("data-fina-done")) return;
      var handle =
        slot.getAttribute("data-fina-handle") ||
        handleFromUrl(slot.getAttribute("data-fina-url"));
      var data = handle && window.FINA_RR_MAP[handle];
      if (!data) {
        slot.setAttribute("data-fina-done", "1"); // kein Rating -> Slot bleibt leer
        return;
      }
      var badge = slot.querySelector(".rapid_reviews_stars_badge");
      if (!badge) {
        var url = slot.getAttribute("data-fina-url") || "/products/" + handle;
        badge = document.createElement("div");
        badge.className = "rapid_reviews_stars_badge r_grid";
        badge.setAttribute("data-avg", data[0]);
        badge.setAttribute("data-count", data[1]);
        badge.setAttribute("data-url", url);
        badge.setAttribute("data-r", "1"); // Label aus Rapids Translations-Store (Singular/Plural via r1/r)
        badge.setAttribute("data-qh", "1"); // Q&A unterdrueckt halten (vorher implizit durch data-rco)
        slot.appendChild(badge);
      }
      // Rapids Renderer zeichnet die Sterne. Falls noch nicht geladen: Slot NICHT
      // als done markieren -> ein spaeterer Scan zieht nach.
      if (typeof window.rr_drawStarsBadge === "function") {
        if (!badge.childElementCount) {
          try {
            window.rr_drawStarsBadge(badge);
          } catch (e) {}
        }
        slot.setAttribute("data-fina-done", "1");
      }
    }

    function openSlots() {
      var g = document.querySelector("[data-globo-filter-items]");
      return g ? g.querySelectorAll(".fina-rr-slot:not([data-fina-done])") : [];
    }
    function scan() {
      var slots = openSlots();
      for (var i = 0; i < slots.length; i++) fillSlot(slots[i]);
    }

    scan(); // falls Globo bereits gerendert hat

    // Globo rendert async + bei jedem Filter/Sort neu (ersetzt ggf. den Grid-Container)
    // -> stabilen Eltern-Knoten beobachten, Grid in scan() jeweils frisch abfragen.
    var host = grid.parentNode || document.body;
    var debounce;
    new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(scan, 80);
    }).observe(host, { childList: true, subtree: true });

    // Bounded Nachzieher, falls rr_drawStarsBadge spaet laedt (stoppt wenn alles done)
    var tries = 0;
    var iv = setInterval(function () {
      scan();
      if (++tries >= 8 || openSlots().length === 0) clearInterval(iv);
    }, 400);
  }

  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", init);
  else init();
})();

// ============================================
// WhatsApp-Vortext mit Chat-ID (Offline-Attribution Slice B)
// Jeder wa.me-Link bekommt ?text= mit "Chat-ID: <Platzierung><Code>" in Zeile 1 und
// nach einer Leerzeile einer offenen Begruessung. Code = 4 Zeichen je Seitenaufruf, ohne
// Cookie/Speicher; Zuordnung Chat <-> Sitzung ueber das href im Pixel-Klick-Event.
// Platzierung: S schwebender Button, M mobiler Button, F Footer, H Header-Icon (Interceptor in
// sections/fina-whatsapp-floating-tab.liquid), W sonstige.
// ============================================
(function () {
  var ALPHABET = "ABCDEFGHJKMNPQRSTUVWXYZ23456789"; // ohne 0/O, 1/I/L
  var code = "";
  var rnd = new Uint8Array(4);
  (window.crypto || window.msCrypto).getRandomValues(rnd);
  for (var i = 0; i < 4; i++) code += ALPHABET[rnd[i] % ALPHABET.length];

  function waHref(url, letter) {
    var text = "Chat-ID: " + letter + code + "\n\nHallo FinA-Team, ich habe eine Frage zu ";
    return url.split("?")[0] + "?text=" + encodeURIComponent(text);
  }
  window.finaWaHref = waHref;

  function placement(a) {
    var tab = a.closest(".whatsapp-floating-tab");
    if (tab) {
      var bp = parseInt(tab.getAttribute("data-fina-mobile-bp"), 10) || 769;
      return window.matchMedia("(max-width: " + bp + "px)").matches ? "M" : "S";
    }
    if (a.closest("footer")) return "F";
    return "W";
  }

  function tag(a) {
    if (!a || !a.href || a.href.indexOf("wa.me/") === -1) return;
    a.href = waHref(a.href, placement(a));
  }

  function tagAll() {
    var links = document.querySelectorAll('a[href*="wa.me/"]');
    for (var i = 0; i < links.length; i++) tag(links[i]);
  }

  // Nachgeladene Links (Apps, Menues) vor dem Klick markieren
  function onIntent(e) {
    tag(e.target && e.target.closest && e.target.closest('a[href*="wa.me/"]'));
  }
  document.addEventListener("pointerdown", onIntent, true);
  document.addEventListener("focusin", onIntent, true);

  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", tagAll);
  else tagAll();
})();


// ============================================
// Back-to-top: unter das Newsletter-Formular (2026-10-24)
// ============================================
// Empire rendert den Button in layout/theme.liquid VOR der Footer-Gruppe; die
// Klaviyo-Formulare sitzen in deren Apps-Section und landeten dadurch unter dem
// Button. Hier wandert er vor die eigentliche Footer-Section (zwischen Formular
// und Footer). Ab 860px ist der Button position:fixed — sichtbar nur mobil.
// Die Empire-Regel `.back-to-top + .shopify-section-group-footer-group
// .site-footer-wrapper` greift danach weiter (Nachbar ist wieder eine
// Footer-Gruppen-Section).

(function() {
  var btn = document.querySelector('[data-back-to-top]');
  var wrapper = document.querySelector('.site-footer-wrapper');
  var footerSection = wrapper && wrapper.closest('.shopify-section');
  if (!btn || !footerSection || !footerSection.parentNode) return;
  if (btn.nextElementSibling === footerSection) return;
  footerSection.parentNode.insertBefore(btn, footerSection);
})();
